import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { IconButton } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { useDocumentRevisionHistory } from '../../../services/documentsService';
import LoaderWrapper from '../../wrapper/LoaderWrapper';
import WindowService from '../../../services/windowService';
import DateService from '../../../services/dateService';

function RevisionHistoryMenuItem(props){
    return (
        <MenuItem onClick={()=>WindowService.openInNewTab(props.download_link)}>
            {`${props.docs_revision_nr+1}.`} {props.docs_name} {DateService.convertDateToFormatYYYYMMDD(props.created)}
        </MenuItem>
    )
}

export default function RevisionHistoryButton(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const {data: revisionData, isLoading} = useDocumentRevisionHistory(open ? props.docsId : undefined)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
        <IconButton
            color="primary"
            sx={{ padding: "5px" }}
            id="revision-history-button"
            aria-controls={open ? 'revision-history-button' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
        >
            <CloudDownloadIcon fontSize="medium" />
      </IconButton>
      <Menu
        id="revision-history-button"
        aria-labelledby="revision-history-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {isLoading && <MenuItem sx={{width: "200px"}}><LoaderWrapper showLoader/></MenuItem>}
        {!isLoading && revisionData?.map(docs => <RevisionHistoryMenuItem {...docs}/>
        )}
      </Menu>
    </div>
  );
}